import { Link } from 'react-router-dom';
import { siteStats, hotKeywords } from '@/mocks/activity';

export default function SidePanel() {
  return (
    <div className="flex flex-col gap-5">
      <section className="bg-primary-500 rounded-lg p-5 text-background-50">
        <h2 className="text-base font-extrabold">蜜糖社区</h2>
        <p className="mt-2 text-sm text-background-50/90 leading-relaxed">
          一个专注生活、娱乐、文化、技术等多元兴趣的交流社区。在这里，你的每一次分享都值得被认真回应。
        </p>
        <div className="mt-4 grid grid-cols-2 gap-3">
          {siteStats.map((stat) => (
            <div key={stat.key}>
              <p className="text-lg font-extrabold">{stat.value}</p>
              <p className="text-[11px] text-background-50/80">{stat.label}</p>
            </div>
          ))}
        </div>
        <Link
          to="/about"
          className="mt-5 inline-flex items-center gap-1.5 rounded-md bg-background-50 text-primary-700 text-sm font-label font-bold px-4 py-2 whitespace-nowrap transition-colors cursor-pointer hover:bg-background-100"
        >
          了解更多
          <i className="ri-arrow-right-line" />
        </Link>
      </section>

      <section className="bg-background-50 border border-background-200 rounded-lg p-5">
        <div className="flex items-center gap-2 mb-3">
          <i className="ri-price-tag-3-line text-primary-600" />
          <h2 className="text-base font-extrabold text-foreground-900">热门标签</h2>
        </div>
        <div className="flex flex-wrap gap-2">
          {hotKeywords.map((kw) => (
            <Link
              key={kw}
              to={`/search?q=${encodeURIComponent(kw)}`}
              className="rounded-full bg-secondary-100 text-secondary-800 px-3 py-1.5 text-xs font-label font-bold hover:bg-secondary-200 transition-colors cursor-pointer whitespace-nowrap"
            >
              #{kw}
            </Link>
          ))}
        </div>
      </section>

      <section className="bg-background-50 border border-background-200 rounded-lg p-5">
        <div className="flex items-center gap-2 mb-3">
          <i className="ri-megaphone-line text-accent-600" />
          <h2 className="text-base font-extrabold text-foreground-900">社区公告</h2>
        </div>
        <ul className="space-y-2.5 text-sm text-foreground-600">
          <li className="flex gap-2">
            <span className="text-accent-500 mt-1.5">●</span>
            新用户发布话题前，建议先阅读社区公约。
          </li>
          <li className="flex gap-2">
            <span className="text-accent-500 mt-1.5">●</span>
            本周「阳台种植」话题活动进行中，欢迎参与。
          </li>
          <li className="flex gap-2">
            <span className="text-accent-500 mt-1.5">●</span>
            本站为演示站点，所有数据均为示例内容。
          </li>
        </ul>
      </section>
    </div>
  );
}